import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2AA24C"
    },
    secondary: {
      main: "#2874A4"
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF"
    }
  },
});

export default theme;